/* link settings JavaScript/jQuery */
jQuery(function( $ ) {

    $( 'a[href$=".pdf"]' ).prop( 'target',  '_blank' ).prop( 'rel', 'no_follow' );

    function link_is_external( link ) {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if ( msie ) {
            return false;
        }

        var href = $( link ).prop( 'href' ),
            url;

        if ( href == '' || href == '#' || href.indexOf( 'tel:' ) == 0 ) {
            return false;
        }

        if ( ! URL ) {
            return false;
        }

        url  = new URL( href );

        if ( url.hostname == '' ) {
            return false;
        }

        return ( url.hostname !== window.location.hostname );

    }

    $( 'a' ).each( function() {
        if ( link_is_external( $( this ) ) ) {
            $( this ).prop( 'target',  '_blank' ).prop( 'rel', 'no_follow' );
        }
    });

});
